import * as React from 'react';

export const LockedIcon = () => (
  <svg
    id="interfaceLocked"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M12.3965 2C13.3656 2.00517 14.6124 2.08644 15.5479 3.05566C16.5721 4.11689 17 5.99265 17 9C18.1046 9 19 9.89543 19 11V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V11C5 9.89543 5.89543 9 7 9C7 5.99265 7.42791 4.11689 8.45215 3.05566C9.38759 2.08644 10.6344 2.00517 11.6035 2H12.3965ZM12 12C10.8954 12 10 12.8954 10 14C10 14.7398 10.4029 15.3835 11 15.7295V18H13V15.7295C13.5971 15.3835 14 14.7398 14 14C14 12.8954 13.1046 12 12 12ZM12 4C10.7939 4 10.2693 4.05199 9.89062 4.44434C9.46719 4.88323 9 6.00777 9 9H15C15 6.00777 14.5328 4.88323 14.1094 4.44434C13.7307 4.05199 13.2061 4 12 4Z"
    />
  </svg>
);

export const UnlockedIcon = () => (
  <svg
    id="interfaceUnlocked"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 14.0004C14 15.105 13.1046 16.0004 12 16.0004C10.8954 16.0004 10 15.105 10 14.0004C10 12.8958 10.8954 12.0004 12 12.0004C13.1046 12.0004 14 12.8958 14 14.0004Z"
      fill="currentColor"
    />
    <path d="M13 15.0004V18.0004H11V15.0004H13Z" fill="currentColor" />
    <path
      d="M17 19.0004V21.0004H7V19.0004H17ZM17 11.0004H7V21.0004L6.7959 20.9896C5.85435 20.8942 5.1062 20.146 5.01074 19.2045L5 19.0004V11.0004C5 9.89581 5.89543 9.00038 7 9.00038H17C18.1046 9.00038 19 9.89581 19 11.0004V19.0004L18.9893 19.2045C18.8938 20.146 18.1457 20.8942 17.2041 20.9896L17 21.0004V11.0004Z"
      fill="currentColor"
    />
    <path
      d="M12 2.00038C13.003 2.00038 14.4788 1.9484 15.5479 3.05605C16.5721 4.11728 17 5.99303 17 9.00038H15C15 6.00815 14.5328 4.88362 14.1094 4.44472C13.7307 4.05237 13.2061 4.00038 12 4.00038C11.4318 4.00038 10.974 4.00162 10.5723 4.05409C10.1796 4.1054 9.92252 4.19772 9.74023 4.32363C9.43441 4.53487 9 5.09508 9 7.00038H7C7 4.90584 7.46163 3.46589 8.60352 2.67714C9.14493 2.30329 9.74931 2.14537 10.3135 2.07167C10.8688 1.99914 11.4636 2.00038 12 2.00038Z"
      fill="currentColor"
    />
  </svg>
);
